import {NoteCategoryDataModel} from '../../../../models/notes/note-category-data.model';
import {NoteTypeDataModel} from '../../../../models/notes/note-type-data.model';
import {StaticDataService} from '../../../../services/static-data.service';

export class TdoNoteFilterModel {
  notesCategories: NoteCategoryDataModel[] = [];
  notesTypes: NoteTypeDataModel[] = [];

  isFullView: boolean = true;
  isCondensedView: boolean = false;

  isShowCreatedOn: boolean = true;
  isShowCreatedBy: boolean = true;
  isShowModifiedOn: boolean = true;
  isShowModifiedBy: boolean = true;

  isShowAlertNotes: boolean = false;

  addNoteFilterCategoriesByIds(staticDataService: StaticDataService, categoryIds: string[]) {
    for (const id of categoryIds) {
      const model = new NoteCategoryDataModel();
      model.enumNoteCategoryID = id;
      model.enumNoteCategory = staticDataService.validValueItems.find(p => p.ValidValueItemId === id);
      this.notesCategories.push(model);
    }
  }

  addNoteFilterTypesByIds(staticDataService: StaticDataService, typeIds: string[]) {
    for (const id of typeIds) {
      const model = new NoteTypeDataModel();
      model.enumNoteTypeID = id;
      model.enumNoteType = staticDataService.validValueItems.find(p => p.ValidValueItemId === id);
      this.notesTypes.push(model);
    }
  }
}
